import { render } from "./BuTaskDetail.vue?vue&type=template&id=1e4b45d7&scoped=true"
import script from "./BuTaskDetail.vue?vue&type=script&lang=js"
export * from "./BuTaskDetail.vue?vue&type=script&lang=js"

import "./BuTaskDetail.vue?vue&type=style&index=0&id=1e4b45d7&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4b45d7"]])

export default __exports__